import React from 'react';
import { Bookmark, Report } from 'core/slices/models';
import { ListGroup, Row } from 'react-bootstrap';
import {
  BookmarkFill,
  PlusCircle,
  ThreeDotsVertical,
} from 'react-bootstrap-icons';
import './ReportNavBookmarkList.scss';

interface ReportNavBookmarkListProps {
  elem: Report;
  activeBookmark: Bookmark | null;
  onAddBookmarkClickMenu: () => void;
  onSelectBookMarkClickMenu: (bookmark: Bookmark) => void;
  onEditBookmarkClickMenu: (bookmark: Bookmark) => void;
}

export const ReportNavBookmarkList: React.FC<ReportNavBookmarkListProps> = ({
  elem,
  activeBookmark,
  onAddBookmarkClickMenu,
  onSelectBookMarkClickMenu,
  onEditBookmarkClickMenu,
}) => {
  // Check if activeBookmark is in this group
  const isActiveGroup =
    !!activeBookmark && elem.bookmarks.some(b => b.id === activeBookmark.id);
  return (
    <Row
      className={`bookmark-wrapper${
        isActiveGroup ? ' active-group' : ' inactive-group'
      }`}
    >
      <ListGroup variant="flush">
        <ListGroup.Item
          className="d-flex align-items-center add-bookmark-item"
          key={0}
          onClick={onAddBookmarkClickMenu}
        >
          <PlusCircle className="me-2" />
          <span className="text-truncate">Add new Bookmark</span>
        </ListGroup.Item>
        {elem.bookmarks.length > 0 &&
          elem.bookmarks.map((bookmark: Bookmark) => (
            <ListGroup.Item
              className={
                'd-flex align-items-center bookmark-list-item' +
                (activeBookmark?.id === bookmark.id ? ' active' : '')
              }
              key={bookmark.id}
            >
              <BookmarkFill className="me-2" />
              <span
                className="text-truncate bookmark-item"
                onClick={() => onSelectBookMarkClickMenu(bookmark)}
              >
                {bookmark.name}
              </span>
              {activeBookmark?.id === bookmark?.id ? (
                <ThreeDotsVertical
                  className="ms-auto dots"
                  onClick={() => onEditBookmarkClickMenu(bookmark)}
                />
              ) : (
                <></>
              )}
            </ListGroup.Item>
          ))}
      </ListGroup>
    </Row>
  );
};
